var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_1291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.88599 7.70724C8.94482 7.70724 9.86169 7.32749 10.6108 6.57822C11.36 5.82908 11.7397 4.91246 11.7397 3.8535C11.7397 2.79491 11.36 1.87817 10.6107 1.12878C9.86145 0.379759 8.9447 0 7.88599 0C6.82703 0 5.9104 0.379759 5.16125 1.1289C4.41211 1.87804 4.03223 2.79479 4.03223 3.8535C4.03223 4.91246 4.41211 5.8292 5.16138 6.57834C5.91064 7.32736 6.82739 7.70724 7.88599 7.70724Z",
    fill: "url(#paint0_linear_10_1291)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.629 12.3032C14.6074 11.9914 14.5637 11.6513 14.4994 11.2922C14.4344 10.9304 14.3508 10.5883 14.2507 10.2757C14.1473 9.9526 14.0067 9.63351 13.8329 9.32772C13.6525 9.01034 13.4406 8.73397 13.2028 8.50656C12.9541 8.26864 12.6497 8.07736 12.2976 7.93783C11.9468 7.79904 11.558 7.72873 11.1421 7.72873C10.9788 7.72873 10.8208 7.79575 10.5157 7.99435C10.328 8.11679 10.1084 8.25839 9.86328 8.41501C9.65369 8.54855 9.36975 8.67367 9.01904 8.78695C8.67688 8.89767 8.32947 8.95382 7.98657 8.95382C7.64368 8.95382 7.29639 8.89767 6.95386 8.78695C6.60352 8.67379 6.31958 8.54867 6.11023 8.41513C5.86743 8.25998 5.64771 8.11838 5.45715 7.99423C5.15247 7.79562 4.99438 7.72861 4.83105 7.72861C4.41504 7.72861 4.02637 7.79904 3.67566 7.93796C3.32385 8.07724 3.01929 8.26852 2.77039 8.50668C2.53271 8.73422 2.32068 9.01046 2.1405 9.32772C1.9668 9.63351 1.82617 9.95248 1.72266 10.2758C1.62268 10.5885 1.53906 10.9304 1.47412 11.2922C1.40979 11.6508 1.36609 11.991 1.34448 12.3035C1.32324 12.6097 1.3125 12.9274 1.3125 13.2484C1.3125 14.0836 1.578 14.7597 2.10156 15.2584C2.61865 15.7504 3.30286 16.0001 4.13489 16.0001H11.839C12.671 16.0001 13.355 15.7505 13.8722 15.2584C14.3959 14.7601 14.6614 14.0838 14.6614 13.2482C14.6613 12.9259 14.6504 12.6079 14.629 12.3032Z",
    fill: "url(#paint1_linear_10_1291)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_1291",
    x1: 7.88599,
    y1: 0,
    x2: 7.88599,
    y2: 7.70724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10_1291",
    x1: 7.98694,
    y1: 7.72861,
    x2: 7.98694,
    y2: 16.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_1291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSel);
export default __webpack_public_path__ + "static/media/profileSel.65364ce8bec7e477233d80d8dd006442.svg";
export { ForwardRef as ReactComponent };